import { Box, Text } from "@mantine/core";
import React from "react";

const MultilineBadge = ({ text }) => {
  return (
    <Box
      bg="#667C99"
      px="sm"
      py={6}
      style={{
        borderRadius: 999,
        whiteSpace: "normal",
        wordBreak: "break-word",
      }}
    >
      <Text
        size="xs"
        fw={760}
        c="white"
        ta="center"
        lh={1.3}
        style={{
          letterSpacing: "0.05em",
          wordSpacing: "0.03em",
        }}
      >
        {text.toUpperCase()}
      </Text>
    </Box>
  );
};

export default MultilineBadge;
